export const UserFinanceTypesEnum = {

    PERSONAL_WALLET: "کیف پول شخصی",
    NON_WITHDRAWABLE_WALLET: "کیف پول جیم پین",
    INCOME_WALLET: "کیف پول درآمد"
}
